import { EnvironmentProviders, makeEnvironmentProviders, Provider } from '@angular/core';

import { provideBaasInitialized } from '@lvflanders/bar-ng';

import { ApiModule } from './api/api.module';
import { TevredenheidsmeterStartupService } from './services/tevredenheidsmeter-startup-service';

export function provideStartschermTevredenheidsmeter() {
    const providers: (Provider | EnvironmentProviders)[] = [ApiModule.forRoot({}).providers, provideBaasInitialized(TevredenheidsmeterStartupService)];
    return makeEnvironmentProviders(providers);
}
